import { defineMessages } from 'react-intl';

export default defineMessages({
    Download: {
        id: 'cep.components.sgDocumentDetails.Download',
        defaultMessage: 'Download'
    },
    Click: {
        id: 'cep.components.sgDocumentDetails.Click',
        defaultMessage: 'Click'
    },
    Here: {
        id: 'cep.components.sgDocumentDetails.Here',
        defaultMessage: 'here'
    },
    NewBusinessInformation: {
        id: 'cep.components.sgDocumentDetails.NewBusinessInformation',
        defaultMessage: 'New Business Information'
    },
    DocumentsByPost: {
        id: 'cep.components.sgDocumentDetails.DocumentsByPost',
        defaultMessage: 'if you require your documents by post.'
    },
    ConsiderEnvironment: {
        id: 'cep.components.sgDocumentDetails.ConsiderEnvironment',
        defaultMessage: 'Please consider the environment before selecting'
    },
    TickDocuments: {
        id: 'cep.components.sgDocumentDetails.TickDocuments',
        defaultMessage: 'Tick the document(s) you require. Please consider the environment before selecting'
    },
    PostNow: {
        id: 'cep.components.sgDocumentDetails.PostNow',
        defaultMessage: 'Post now'
    },
    DocumentsSent: {
        id: 'cep.components.sgDocumentDetails.DocumentsSent',
        defaultMessage: '{numberDocuments} document(s) will be sent to you by post within 3 to 6 working days. '
    },
    CvcNotification: {
        id: 'cep.components.sgDocumentDetails.CvcNotification',
        defaultMessage: 'If you\'ve previously asked to receive documents in large print, audio or braille, these will be provided. '
    },
    ReadMore: {
        id: 'cep.components.sgDocumentDetails.ReadMore',
        defaultMessage: 'Read more'
    },
    ClickHere: {
        id: 'cep.components.sgDocumentDetails.ClickHere',
        defaultMessage: 'Click the links below to view Saga Policy Books:'
    },
    HomeLink: {
        id: 'cep.components.sgDocumentDetails.HomeLink',
        defaultMessage: 'Home'
    },
    MotorLink: {
        id: 'cep.components.sgDocumentDetails.MotorLink',
        defaultMessage: 'Motor'
    },
    LandlordLink: {
        id: 'cep.components.sgDocumentDetails.LandlordLink',
        defaultMessage: 'Landlord'
    },
    DdaFormatLabel: {
        id: 'cep.components.sgDocumentDetails.DdaFormatLabel',
        defaultMessage: 'Do you require your documents in an alternative format?'
    },
    HealthLink: {
        id: 'cep.components.sgDocumentDetails.HealthLink',
        defaultMessage: 'Health'
    },
    TravelLink: {
        id: 'cep.components.sgDocumentDetails.TravelLink',
        defaultMessage: 'Travel'
    }
});
